import { useConfigHelper } from '@ilteducation/config';
import { OrganizationsResponseBody, MeResponseBody } from '@ilteducation/my-account-types';
import axios from 'axios';

const { getApiUrl } = useConfigHelper();
export const getMe = async (): Promise<MeResponseBody> => {
  const response = await axios.get<MeResponseBody>(`${getApiUrl('my-account', false)}/me`);

  return response.data;
};

export const getMyOrganizations = async (limit: number, offset: number): Promise<OrganizationsResponseBody> => {
  const response = await axios.get<OrganizationsResponseBody>(`${getApiUrl('my-account', false)}/me/organizations`, {
    params: {
      limit,
      offset,
    },
  });

  return response.data;
};
